import { Accordion } from '@ark-ui/react';
import cn from 'classnames';

import { usePdfHelpers } from 'src/hooks/usePdfHelpers';

import { setJumpLinkAttributes } from 'src/utils/jumpLinks';

import CaretUp from 'assets/icons/caret-up.svg';

import RichText from 'components/BaseHelpers/RichText';
import Text from 'components/BaseHelpers/Text';

import styles from './AccordionSection.module.scss';

export type AccordionSectionProps = {
  heading: string;
  description: string;
  panels: {
    label: string;
    content: string;
  }[];
  jumpLinkLabel?: string;
};

const AccordionSection = (props: AccordionSectionProps): JSX.Element => {
  const { heading, description, panels, jumpLinkLabel } = props;
  const { isPdf } = usePdfHelpers();

  const panelsToRender = panels.filter((panel) => panel.label && panel.content);

  if (panelsToRender.length === 0) {
    return <></>;
  }

  const getValue = (index: number) => `item-${index}`;

  return (
    <div className={cn(styles.main, 'container-10')} {...setJumpLinkAttributes(jumpLinkLabel)}>
      <Text tag="h2" className={cn('heading-h3', styles.heading)} field={heading} />
      <RichText className="heading-h5" field={description} noDefaultBodyStyle={true} />
      <Accordion.Root
        multiple={true}
        className={styles['accordion-root']}
        defaultValue={isPdf ? panelsToRender.map((_, index) => getValue(index)) : undefined}
        disabled={isPdf}
      >
        {panelsToRender.map((panel, index) => (
          <Accordion.Item className={styles.item} value={getValue(index)} key={index}>
            <Accordion.ItemTrigger className={cn('heading-h4', styles.trigger)}>
              <Text field={panel.label} />
              <CaretUp className={styles.icon} />
            </Accordion.ItemTrigger>
            <Accordion.ItemContent className={styles.content}>
              <RichText className={cn('body-med', styles.body)} field={panel.content} />
            </Accordion.ItemContent>
          </Accordion.Item>
        ))}
      </Accordion.Root>
    </div>
  );
};

export default AccordionSection;
